var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 43,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "confirm_svg__a",
    width: "171.4%",
    height: "171.4%",
    x: "-35.7%",
    y: "-21.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "confirm_svg__b",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#confirm_svg__a)",
    xlinkHref: "#confirm_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ff474b",
    xlinkHref: "#confirm_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.974 18.509l-7.604 7.473c-.703.69-1.842.69-2.545 0l-3.8-3.735c-.7-.687-.7-1.803 0-2.492a1.818 1.818 0 012.536 0l1.27 1.248a1.817 1.817 0 002.535 0l5.073-4.986c.7-.69 1.834-.69 2.535 0a1.74 1.74 0 010 2.492"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmError);
export default __webpack_public_path__ + "static/media/confirm-error.f34442a3.svg";
export { ForwardRef as ReactComponent };